import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { applyRuntimeConfig } from './environments/environment-base';
import { environment } from './environments/environment';

applyRuntimeConfig(environment)
  .then(() => bootstrapApplication(AppComponent, createAppConfig()))
  .catch((error) => console.error(error));
